// src/components/PrivateRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../utils/auth';
import { buildLoginUrl } from '../utils/authRedirect';

export default function PrivateRoute({ children }) {
  const location = useLocation();

  // isLoggedIn() controlla anche la scadenza del JWT (niente refresh token
  // nell'app): con token scaduto si va al login invece di far fallire le API.
  if (!isLoggedIn()) {
    // /login?redirect=<pagina richiesta>: dopo il login si torna qui
    return <Navigate to={buildLoginUrl(location)} replace />;
  }

  return children;
}
